import PropTypes from "prop-types"

import { IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

const ProductPrice = ({ product }) => {
  const onSale = product.reg !== product.selling
  const savePercent = (
    ((product.reg - product.selling) / product.reg) *
    100
  ).toFixed(0)

  const globaleAttrs = {
    container: {},
    display: {},
    reg: {},
  }
  if (sl.config.global_e_pricing == "fixed") {
    if (onSale) {
      globaleAttrs.reg["data-fp"] =
        `"{${sl.config.site_country_for_analytics}": "${product.reg}"}`

      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${product.selling}"}`
    } else {
      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${product.reg}"}`
    }
  } else {
    globaleAttrs.container["data-ge-product-container"] = true
    if (onSale) {
      globaleAttrs.reg["data-ge-list-price"] = true
      globaleAttrs.display["data-ge-sale-price"] = true
    } else {
      globaleAttrs.display["data-ge-price"] = true
    }
  }

  return (
    <div
      className={cn(
        "body-sm desktop:flex-row desktop:items-center inline-flex flex-col items-start gap-6 font-semibold uppercase"
      )}
      {...globaleAttrs.container}
    >
      {IS_JEWLR() ? (
        <>
          {onSale ? (
            <>
              <p>
                from{" "}
                <span
                  className="font-semibold"
                  data-cy={`collection-product-price-${product.style_code}`}
                  {...globaleAttrs.display}
                >
                  {to_currency(product.selling, { precision: 0 })}
                </span>
                <strike
                  className="text-grey-400 ml-6 font-semibold"
                  {...globaleAttrs.reg}
                >
                  {to_currency(product.reg, { precision: 0 })}
                </strike>
              </p>
              <span className="text-primary border-primary h-26 inline-flex items-center justify-center rounded-full border px-6 font-semibold uppercase">
                {savePercent}% off
              </span>
            </>
          ) : (
            <>
              from{" "}
              <span
                className="font-semibold"
                data-cy={`collection-product-price-${product.style_code}`}
                {...globaleAttrs.display}
              >
                {to_currency(product.reg, { precision: 0 })}
              </span>
            </>
          )}
        </>
      ) : (
        <span
          className="text-emerald"
          data-cy={`collection-product-price-${product.style_code}`}
        >
          {to_currency(product.selling, { precision: 0 })}
        </span>
      )}
    </div>
  )
}

ProductPrice.propTypes = {
  product: PropTypes.object,
}

export default ProductPrice
